/* eslint-disable prettier/prettier */
import { Breadcrumbs, Checkbox, IconButton } from "@material-ui/core";
import AppsIcon from "@material-ui/icons/Apps";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import FormatListBulletedOutlinedIcon from "@material-ui/icons/FormatListBulletedOutlined";
import { IFolderPathProps } from "../../../../../@types/components/filePathProps.types";
import ArrowBack from "@material-ui/icons/ArrowBack";

interface FilePathProps {
	path: IFolderPathProps[];
	viewStyle: "LIST" | "GRID";
	handleChangeStyle: (viewType: "LIST" | "GRID") => void;
	handleChangeFolder: (parent_folder_id: string, parent_folder_name: string) => Promise<void>;
	redirectFolder: (index: number) => void;
}

const FilePath = ({ path, viewStyle, handleChangeStyle, redirectFolder }: FilePathProps) => {
	// console.log("file path", path);
	return (
		<div className="filePathWithSelectBox">
			<div>
				<Breadcrumbs separator="/" aria-label="breadcrumb">
					{path.map((folder, index) => {
						return (
							<span
								className="breadcrumb-text"
								style={
									index === path.length - 1
										? {
												textTransform: "capitalize",
												fontWeight: "800",
												color: "#28a745",
												cursor: "pointer"
										  }
										: { textTransform: "capitalize", cursor: "pointer", color: "#28a745!important" }
								}
								key={index}
								onClick={() => redirectFolder(index)}
							>
								{folder.folder_name}
								{index === path.length - 1 ? " /" : null}
							</span>
						);
					})}
				</Breadcrumbs>
				{path.length === 1 ? null : (
					<div style={{ marginTop: 10 }}>
						<IconButton style={{ padding: 1.5 }} onClick={() => redirectFolder(path.length - 2)}>
							<ArrowBack style={{ color: "black" }} fontSize="small" />
						</IconButton>
					</div>
				)}
			</div>
			<div>
				{viewStyle === "GRID" ? (
					<FormatListBulletedOutlinedIcon
						style={{ cursor: "pointer" }}
						onClick={() => handleChangeStyle("LIST")}
					/>
				) : (
					<AppsIcon style={{ cursor: "pointer" }} onClick={() => handleChangeStyle("GRID")} />
				)}
				<InfoOutlinedIcon style={{ cursor: "pointer", marginLeft: "1rem" }} />
			</div>
		</div>
	);
};

export default FilePath;
